import { Injectable } from "@angular/core";
import { distinctUntilChanged, mergeMap, Observable, of, ReplaySubject, takeUntil, withLatestFrom } from "rxjs";
import * as fromRoot from '@app/reducers';
import { Store } from '@ngrx/store';
import { AccountActions } from '@app/core/actions';

@Injectable({
  providedIn: 'root'
})
export class LastActiveTeamGuard {

  constructor(
    private store$: Store<fromRoot.State>,
  ) { }

  canActivate(): Observable<boolean> {
    return this.lastActiveTeam().pipe(mergeMap((lastActiveTeam: boolean) => {
      return of(lastActiveTeam)
    }));

  }

  lastActiveTeam(): Observable<boolean> {
    const activeTeam$ = new ReplaySubject<boolean>();
    this.store$.pipe(
      withLatestFrom(
        this.store$.select(fromRoot.getActiveTeam),
        this.store$.select(fromRoot.getUserTeamsLoading),
        this.store$.select(fromRoot.getUserTeamsLoaded),
      ),
      distinctUntilChanged(),
      takeUntil(activeTeam$),
    ).subscribe(([store, activeTeam, userTeamsLoading, userTeamsLoaded]: any) => {
      if (!userTeamsLoading && activeTeam) {
        activeTeam$.next(true);
      } else if (!userTeamsLoading && !userTeamsLoaded) {
        this.store$.dispatch(AccountActions.LoadUserTeams());
      } else if (!activeTeam && userTeamsLoaded) {
        activeTeam$.next(false);
      }

    });

    return activeTeam$.asObservable();
  }
}